import {
  SET_EDITED_FIELDS,
  UPDATE_EDITED_FIELDS,
} from '@/store/mutation-types';

const mutations = {
  [SET_EDITED_FIELDS](state, fields) {
    state.editedFields = fields;
  },
  [UPDATE_EDITED_FIELDS](state, field) {
    state.editedFields.push(field);
  },
};

export default mutations;
